import React, { FC } from 'react'

import { Chip, Stack, useTheme } from '@mui/material'
import { Currency, getCurrencySymbol } from '@caterdesk/utils--money'

import { useTranslation } from 'react-i18next'
import { numberFormat } from '@/helpers/numbers'

type Props = {
  currency: string
  subsidy: number
  balance: number
  unlimitedSubsidy: boolean
  topUpEnabled?: boolean
}

const SubsidyAndBalance: FC<Props> = ({
  unlimitedSubsidy,
  balance,
  subsidy,
  currency,
  topUpEnabled,
}) => {
  const { t } = useTranslation()
  const { palette } = useTheme()

  return (
    <Stack width="100%" direction="row" flexWrap="nowrap">
      {topUpEnabled && (
        <Chip
          color="default"
          sx={{
            backgroundColor: palette.inverted.light,
            borderTopRightRadius: '0',
            borderBottomRightRadius: '0',
            '& .MuiChip-label': {
              paddingRight: 1,
            },
          }}
          icon={
            currency ? (
              <Chip
                sx={{
                  '& .MuiChip-label': {
                    overflow: 'visible',
                    paddingRight: '9px',
                  },
                }}
                size="small"
                color="primary"
                variant="filled"
                label={getCurrencySymbol(currency as Currency) ?? '¤'}
              />
            ) : undefined
          }
          label={numberFormat(balance)}
        />
      )}

      <Chip
        sx={{
          borderTopLeftRadius: topUpEnabled ? '0' : undefined,
          borderBottomLeftRadius: topUpEnabled ? '0' : undefined,
          '& .MuiChip-label': {
            overflow: 'hidden',
            paddingLeft: 0.5,
          },
          width: '100%',
        }}
        color="success"
        label={unlimitedSubsidy ? t('cc:unlimited') : `+ ${numberFormat(subsidy)} ${t('cc:free')}`}
      />
    </Stack>
  )
}

export default React.memo(SubsidyAndBalance)
